module.exports = __webpack_public_path__ + "static/media/more-onoiwa.a75bb911.png";